import { ROUTE_PATH } from "@/common/constants/routing";
import { AppPermission, PoolItemDto, PoolItemReferenceDto } from "@/core/api/generated/v1";

import {
  BaseEntityLink,
  BaseEntityLinkInheritableProps,
} from "../components/EntityLink/BaseEntityLink";
import PoolItemInline, { PoolItemInlineProps } from "./PoolItemInline";

interface Props extends BaseEntityLinkInheritableProps {
  entity: PoolItemDto | PoolItemReferenceDto | null | undefined;
  entityId?: string | null;
  inlineProps?: Partial<PoolItemInlineProps>;
}

export default function PoolItemLink({ entity, entityId, inlineProps, ...otherProps }: Props) {
  return (
    <BaseEntityLink
      entity={entity}
      entityId={entityId}
      permissions={[AppPermission.FleetAppAccess, AppPermission.PoolRead]}
      to={ROUTE_PATH.POOL_ITEM_VIEW(entity?.id || entityId || "")}
      content={<PoolItemInline entity={entity} entityId={entityId} {...inlineProps} />}
      {...otherProps}
    />
  );
}
